/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_DescriptionInputs */

const en_gc_resources_faq_description = /** @type {(inputs: Gc_Resources_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The practical details, before your next workbook.`)
};

const zh_gc_resources_faq_description = /** @type {(inputs: Gc_Resources_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开下一份工作簿之前，先了解这些实用信息。`)
};

/**
* | output |
* | --- |
* | "The practical details, before your next workbook." |
*
* @param {Gc_Resources_Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_description = /** @type {((inputs?: Gc_Resources_Faq_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_description(inputs)
	return zh_gc_resources_faq_description(inputs)
});
export { gc_resources_faq_description as "gc.resources.faq.description" }